import { render, staticRenderFns } from "./CheckoutTenderPad.vue?vue&type=template&id=79a852fe"
import script from "./CheckoutTenderPad.vue?vue&type=script&lang=js"
export * from "./CheckoutTenderPad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports